/* eslint-disable react/prop-types */
import React, { Fragment } from 'react';
import Avatar from 'react-avatar';

export default function StudentCard(props) {
  const { student } = props;
  return (
    <Fragment>
      <Avatar
        size="40"
        round="20px"
        src={student.profilePhotoUrl}
        name={student.studentName}
      />
      <div className="student-card">
        <div>{student.studentName}</div>
        <div>{student.classes}</div>
        <div>{student.menuName}</div>
      </div>
    </Fragment>
  );
}
